import { render, staticRenderFns } from "./EventInfoOld.vue?vue&type=template&id=13664518&scoped=true"
import script from "./EventInfoOld.vue?vue&type=script&lang=js"
export * from "./EventInfoOld.vue?vue&type=script&lang=js"
import style0 from "./EventInfoOld.vue?vue&type=style&index=0&id=13664518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13664518",
  null
  
)

export default component.exports